import { EPSG } from "../../../lib/projection";
export class MapServiceApi {
    constructor(urls, service_info) {
        this.urls = urls;
        this.service_info = service_info;
        this.layer_choices = [];
    }
    select_layers(...layer_nums) {
        this.layer_choices = layer_nums;
    }
    get is_cached() {
        return !!this.service_info.tileInfo;
    }
    get details() {
        return {
            DPI: 96,
            FORMAT: "png32",
            F: "image",
            TRANSPARENT: true,
            LAYERS: `show:${this.layer_choices.join(',')}`
        };
    }
    get endpoints() {
        return this.urls;
    }
    get extent() {
        return [
            this.service_info.fullExtent.xmin,
            this.service_info.fullExtent.ymin,
            this.service_info.fullExtent.xmax,
            this.service_info.fullExtent.ymax
        ];
    }
    get projection() {
        return EPSG(this.service_info.spatialReference.latestWkid);
    }
    get origin() {
        if (this.is_cached)
            return [this.service_info.tileInfo.origin.x, this.service_info.tileInfo.origin.y];
        return [0, 0];
    }
    get tile_size() {
        if (this.is_cached)
            return [this.service_info.tileInfo.rows, this.service_info.tileInfo.cols];
        return [0, 0];
    }
    get cached_resolutions() {
        if (this.is_cached)
            return this.service_info.tileInfo.lods.map(l => l.resolution);
        return [];
    }
}
